/***** cnt show *****/
  $(document).ready(function(){
    $('body.specialfeature #PageContainer, body.specialfeature .footer-wrapper').removeClass('hide');
    $('body.specialfeature #PageContainer, body.specialfeature .footer-wrapper').addClass('show');
  });
/***** /cnt show *****/





/***** slick *****/
  $(document).ready(function(){
    let slidesToShowNum = 3;
    let item = $('.specialfeature_herosld > li').length;
    if (item <= slidesToShowNum) {
      for (i = 0; i <= slidesToShowNum * 2 - item; i++) {
      $('.specialfeature_herosld > li:nth-child(' + i + ')').clone().appendTo('.specialfeature_herosld');
      }
    }
    if (item < slidesToShowNum) {
      slidesToShowNum = item;
    }
    $('.specialfeature_herosld').slick({
      arrows: false,
      // autoplay: false,
      autoplay: true,
      autoplaySpeed: 4000,
      // cssEase: 'cubic-bezier(0.5,-1,0.5,2)',
      // easing: 'easeOutBounce',
      // initialSlide: 0,
      pauseOnFocus: false,
      // slidesToShow: 3,
      slidesToShow: slidesToShowNum,
      speed: 1000,
      responsive: [{
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: '8%',
          slidesToShow:1
        }
      }]
    });
  });

  $(document).ready(function(){

    $('.specialfeature_cntsld').slick({
      autoplaySpeed: 4000,
      arrows: false,
      autoplay: true,
      fade: true,
      infinite: true, 
      pauseOnFocus: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 0,
    });
  });

	/* $(function(){
	  var slidesToshow_val = 5;
	  var slidesToshow_leng = $('ul li').length;
	  if(slidesToshow_leng > slidesToshow_val){
		slidesToshow_val = slidesToshow_leng;
	  }
	  $('.specialfeature_herosld').slick({
	   slidesToShow: slidesToshow_val,
	   autoplay: true,
	   autoplaySpeed: 1800,
	   centerMode: true,
	  });
	}); */
/***** /slick *****/





/***** drawer *****/
  $(document).ready(function() {
    $('button.drawer_open').on('click', function(){
      $('nav#drawer').removeClass('drawer_hide').addClass('drawer_show');
      // $('main#MainContent > div:not(:eq(0))').animate({ opacity: 0 }, { duration: 400, easing: 'swing'});
    });
  });

  $(document).ready(function() {
    $('a.mobile-menu--close-btn, #drawer a').on('click', function(){
      $('nav#drawer').removeClass('drawer_show').addClass('drawer_hide');
      // $('main#MainContent > div:not(:eq(0))').animate({ opacity: 1 }, { duration: 600, easing: 'swing'});
    });
  });

  $(function () {
    // var headH = $('header').outerHeight();
    // var navH = $('nav').outerHeight();
    // var sclH = headH + navH;
    var animeSpeed = 500;
    $("#drawer a[href^='#']").on({
        "click": function () {
            var href = $(this).attr('href');
            var target = $(href == "#" || href === "" ? "html" : href);
            var position;
            // position = target.offset().top - 100;
            position = target.offset().top - 50;
            // $("body,html").stop().animate({
            $("body,html").animate({
              scrollTop: position
            }, animeSpeed);
            return false;
        }
    });
  });
  
  $(function () {
    var animeSpeed = 500;
    $("#newproducts a[href^='#']").on({
        "click": function () {
          var href = $(this).attr('href');
          var target = $(href == "#" || href === "" ? "html" : href);
          var position;
          position = target.offset().top - 50;
          $("body,html").animate({
            scrollTop: position
          }, animeSpeed);
          return false;
        }
    });
  });
  
  $(function () {
    var animeSpeed = 500;
    $(".specialfeature_herosld a[href^='#']").on({
        "click": function () {
          var href = $(this).attr('href');
          var target = $(href == "#" || href === "" ? "html" : href);
          var position;
          position = target.offset().top - 50;
          $("body,html").animate({
            scrollTop: position
          }, animeSpeed);
          return false;
        }
    });
  });
/***** /drawer *****/





/***** accordion *****/
  $(function() {
    $('.acd_btn').on('click', function() {
      $(this).toggleClass('open');
      $(this).next('.acd_box').slideToggle(500);
    });
  });
/***** /accordion *****/
